// extracted by mini-css-extract-plugin
export var billingAddress = "_rm-g";
export var contactInfo = "_rm-d";
export var customerInfoContainer = "_rm-c";
export var customerInfoContainerMobile = "_rm-h";
export var customerInfoRow = "_rm-a";
export var customerInfoSection = "_rm-b";
export var fullWidthDividerMobile = "_rm-i";
export var imageContainer = "_rm-1";
export var paymentMethod = "_rm-e";
export var priceText = "_rm-6";
export var priceTextMobile = "_rm-7";
export var product = "_rm-0";
export var productImage = "_rm-2";
export var productInfo = "_rm-4";
export var productMobile = "_rm-9";
export var productTitle = "_rm-8";
export var quantityBadge = "_rm-3";
export var quantityText = "_rm-5";
export var shippingAddress = "_rm-f";